import { useEffect, useState, useRef } from 'react';
import { Box, Typography, Alert, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import 'esp-web-tools';

export default function ESPWebTools({
  manifestPath,
  title = 'Sensor',
  description = 'Click the button below to install the firmware on your VPSI Sensor!',
  imagePath
}) {
  const [isSupported, setIsSupported] = useState(false);
  const [error, setError] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setIsSupported(!!navigator.serial);
    const handleError = (event) => {
      if (event.detail && event.detail.error) setError(event.detail.error);
    };
    window.addEventListener('esp-web-install-error', handleError);
    return () => window.removeEventListener('esp-web-install-error', handleError);
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      const btn = buttonRef.current.querySelector('esp-web-install-button');
      if (btn) {
        btn.setAttribute('manifest', manifestPath);
      }
    }
  }, [manifestPath]);

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      {imagePath && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <img 
            src={imagePath} 
            alt={title}
            style={{ 
              maxWidth: '100%', 
              height: 'auto',
              maxHeight: '200px',
              objectFit: 'contain'
            }}
          />
        </Box>
      )}
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {description}
      </Typography>
      
      {isSupported ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <div ref={buttonRef}>
            <esp-web-install-button 
              id="installButton" 
              manifest={manifestPath}
            />
          </div>
          
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </Box>
      ) : (
        <Typography color="error">
          Your browser does not support the firmware installation. Please use Chrome or Edge.
        </Typography>
      )}
    </Paper>
  );
}

ESPWebTools.propTypes = {
  manifestPath: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imagePath: PropTypes.string
}; 